import { ValuablesText } from "../../valuablesInterface";
import {
  Container,
  InsuranceInformation,
  MarginBottomContainer,
} from "./styled";

import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoverageCardDetails } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCardDetails";
import { CoverageCardPrice } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCardPrice";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { SystemErrorAlert } from "Components/Form/Alert/SystemErrorAlert";
import { useTexts } from "Components/TextContext";
import { ValuablesCoverage } from "Store/interfaces/products/coverage";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { CalculationPrice } from "Store/priceCalculation/priceCalculationInterfaces";
import { TextLanguage } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import React from "react";

interface Props {
  texts: ValuablesText;
  lang: TextLanguage;
}

export const ValuablesCoveragePrice = (props: Props): React.ReactElement => {
  const { texts, lang } = props;
  const { getText } = useTexts();

  const coverages = useCoveragePriceCalculations();
  const price = getPrice(coverages);

  if (!isDefined(price)) {
    return <SystemErrorAlert alertId="coveragePrice" />;
  }

  return (
    <>
      <Container>
        <InsuranceInformation>
          <MarginBottomContainer as="p">
            <MarginBottomContainer as="b">
              {texts.name[lang]}
            </MarginBottomContainer>
            {getText("coveragecard.valuables.description")}
          </MarginBottomContainer>
          <CoverageCardPrice price={price.monthlyPricePrecise} />
        </InsuranceInformation>
        <CoverageCardDetails
          product={ProductBackendName.VALUABLES}
          coverage={ValuablesCoverage.VALUABLES}
        />
      </Container>
      <CurrentPriceMessage
        productBackendName={ProductBackendName.VALUABLES}
        coverages={coverages}
        selectedPrices={[
          {
            selectedCoverage: ValuablesCoverage.VALUABLES,
            selectedDeductible: undefined,
            defaultDeductible: undefined,
          },
        ]}
      />
    </>
  );
};

const getPrice = (
  coverages: CoveragePriceCalculation[],
): CalculationPrice | null => {
  if (coverages.length !== 1) {
    return null;
  }

  const prices = coverages[0][1];
  return prices.prices[0];
};
